import * as React from 'react'

import { StyledNativeLink } from './styles'

interface IProps {
  currentOnboardingSlug: string
  isOnboarding: boolean
}

function DirectorLinks(props: IProps) {
  const { isOnboarding } = props

  return isOnboarding ? (
    <StyledNativeLink href="/onboarding">Continue Onboarding</StyledNativeLink>
  ) : (
    <StyledNativeLink data-cy-hint="header-dashboard-link" href="/admin">
      Program Dashboard
    </StyledNativeLink>
  )
}

export default React.memo(DirectorLinks)
